export default __webpack_public_path__ + "static/media/europeaRoulette.264c3766.svg";